import { apiFormData } from '../configs/axiosConfigs';

export const getPropertyComments = async(property_id: string) => {
  return await apiFormData.get(`properties/${property_id}/comments`);
};